import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Container from '../../components/container';
import HeaderHome from '../../components/header';
import FooterHome from '../../components/footer';
import Banner from './banner';
import '../../assets/styles/scss/pages/_jobDetail.scss'
import Content from './content';
import JobDetailCarousel from './content/carousel';
import axiosRc from '../../config/axios-rc';
import { HomeContextProvider } from '../home/context/homeContext';

const JobDetail = () => {
    const { jobId } = useParams();
    const [jobData, setJobData] = useState(null)

    useEffect(() => {
        const getJobDetailData = async () => {
            const { data } = await axiosRc.get(`/jobList/get_job_detail_by_id/${jobId}`);
            if (data) {
                let isExtend = false
                if (data.countExtendHistory > 0 ){
                    isExtend = true
                }
                setJobData({...data, isExtend:isExtend})

                const body = {
                    id: jobId
                }
                await axiosRc.put(`/jobRequest/update_visit`, body);
            }
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
        getJobDetailData()
    }, [])

    return (
        <Container>
            <HomeContextProvider>
                <header className='div-header'>
                    <HeaderHome />
                </header>
                <div className="job-detail-content relative" >
                    <Banner orgUnitId={jobData?.orgUnitId} />
                    <div className='container job-content mx-auto' >
                        <Content job={jobData} />
                    </div>
                    {jobData?.jobReqPositionRelated && jobData?.jobReqPositionRelated.length > 0 &&
                        <div className="job-detail-position">
                            <JobDetailCarousel job={jobData} />
                        </div>
                    }
                </div>
                <footer>
                    <FooterHome />
                </footer>
            </HomeContextProvider>
        </Container>
    )
}

export default JobDetail